import { wrapLazyNavigatorScreen } from '@psl/functions/navigation/utils/wrapNavigatorScreen';
import { lazy } from 'react';

const UserFrontPageContent = lazy(() => import('./UserFrontPageContent'));

export const UserFrontPage = wrapLazyNavigatorScreen(
  () => {
    return <UserFrontPageContent />;
  },
  { headerShown: false },
);
